/**
 * Brand links enum for redirects.
 */
export enum BrandLinks {
    porsche = 'http://www.porsche.com/Mexico',
    audi = 'https://www.audi.com.mx/',
}
